module.exports = __webpack_public_path__ + "img/diw_16_DebtGroup.1a8d6493.png";